module.exports = __webpack_public_path__ + "static/media/Collapse.44094168.svg";